import dayjs from 'dayjs';

export const getAge = (date?: Date | string) => {
  const birthDate = dayjs(date);
  const today = dayjs();
  const age = today.diff(birthDate, 'year');
  
  return age;
};
